import { Button } from "components/ui/Button";
import { useCallback } from "react";
import { TableAction } from "./types";

interface TableRowActionsProps<T extends Record<string, any>> {
  actions: TableAction<T>[];
  row: T;
  index: number;
  align?: 'center' | 'end';
}

const TableRowActions = <T extends Record<string, any>>({
  actions,
  row,
  index,
  align = 'end'
}: TableRowActionsProps<T>) => {
  const renderAction = useCallback((action: TableAction<T>, actionIndex: number) => {
    if (action.render) {
      return action.render(row, actionIndex);
    } else {
      return (
        <Button
          key={actionIndex}
          color={action.variant ? action.variant : 'primary'}
          onClick={() => action.onClick && action.onClick(row, index)}
          round
          disabled={action.disabled?.(row)}
        >
          {action.icon}
          {action.label}
        </Button>
      );
    }
  }, [row, index]);

  return (
    <div className={`flex gap-2 ${align === 'center' ? 'justify-center' : 'justify-end'}`}>
      {actions.map((action, actionIndex) => renderAction(action, actionIndex))}
    </div>
  );
};

export default TableRowActions;
